export const loadPage = (url: string) => fetch(url).then(response => {
  if (!response.ok) {
    return Promise.reject(response)
  }

  return response.text()
})
